import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { parseQuoteParams } from '@nibtravel/quote/common/features/loader';
import queryString from 'query-string';
import { QuoteActions } from '@nibtravel/shared/data-access/quote';
import { DOCUMENT } from '@angular/common';
import { Store } from '@ngxs/store';

@Injectable({
  providedIn: 'root',
})
export class QqcRedirectToHorizontalService {
  constructor(
    private router: Router,
    private store: Store,
    @Inject(DOCUMENT) private document: Document
  ) {}

  public populateFormStateHandler(): void {
    const inputsFromUrl = queryString.parse(this.document.location.search);
    const quote = parseQuoteParams(inputsFromUrl);
    if (inputsFromUrl?.toKosmos) {
      this.store.dispatch(new QuoteActions.SetQuoteParamsToKosmos(quote));
    }
  }
}
